export default "__VITE_ASSET__BrnX64qt__"